"use client"

import { Component } from "react"
import moment from "moment"
import axios from "axios"
import { root_url } from "../../services/API"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import { getCurrency } from "../../common/util"
import routes from "../../routes/URL"
import Toast from "../../components/Toast"
import NutriationTab from "../../components/Nutriation"

import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  Container,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputLabel,
  Switch,
  MenuItem,
  Select as MuiSelect,
  IconButton,
  Tabs,
  Tab,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material"
import Select from "react-select"
import makeAnimated from "react-select/animated"
import DeleteIcon from "@mui/icons-material/Delete"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"
import AddOnsTab from "../../components/AddOn"
import Veg from "../../assets/Veg.png"
import NonVeg from "../../assets/Non-Veg.png"
import Jain from "../../assets/Jain.png"
import EggFood from "../../assets/Egg.png"
import Drinks from "../../assets/Drinks.png"
import ARModelTab from "../../components/ARModelTab"
import Header from "../../components/Header"
import NutritionTab from "../../components/Nutriation"
const animatedComponents = makeAnimated()

// Custom styles to hide scrollbar
const scrollbarHide = {
  "&::-webkit-scrollbar": {
    display: "none",
  },
  scrollbarWidth: "none",
  "-ms-overflow-style": "none",
}

class CreateMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      category_ids: [],
      spaceData: [],

      category: [],
      active: true,
      start_time: "",
      end_time: "",
      food_availabel: "allday",
      menu_type: "veg",
      menu_image: null,
      isModalOpen: false,
      menuCreated: false,
      menuId: null,
      showAttributeVariation: false,
      attributeTabIndex: 0,
      attributes: [],
      variations: [],
      newAttributeName: "",
      newAttributeValue: "",
      attributeValues: [],
      bulkActionAnchorEl: null,
      loadingAttributes: false,
      loadingVariations: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      mainTabIndex: 0, // New state for main tabs
      basePrice: null,
      timeSlots: [], // This was missing
    currentStartTime: "", // This was missing
    currentEndTime: "", // This was missing
    menu_available_time_slot: "allday",
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  state = {
    showAttributeVariation: false,
    showSuccessMessage: true,
  }

  toggleAttributeVariation = () => {
    this.setState({
      showAttributeVariation: !this.state.showAttributeVariation,
      showSuccessMessage: false,
    })
  }

  componentDidMount() {
     const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getCategory()
  }

  getSpaces = async () => {
    console.log("URL_PATH.getSpacesWisePrice", URL_PATH.getSpacesWisePrice)
    try {
      const requestData = {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.state.menuId,
      }
      console.log("requestDatarequestData", requestData)
      const { status, message, area_prices } = await API(this, "post", URL_PATH.getSpacesWisePrice, requestData)

      if (status) {
        console.log("API Response:", { status, message, area_prices })

        // Get the base price from the menu_price field
        const basePrice = Number.parseFloat(document.getElementById("menu_price")?.value)

        // Initialize all final prices with the base price if they're not set
        const updatedSpaceData = area_prices.map((space) => {
          if (!space.area_final_price) {
            return {
              ...space,
              area_final_price: basePrice,
            }
          }
          return space
        })

        this.setState({
          spaceData: updatedSpaceData,
          basePrice: basePrice,
        })
      } else {
        this.showToast(message, "error")
      }
    } catch (error) {
      console.error("API Error:", error)
      this.showToast("Failed to fetch spaces data", "error")
    }
  }


  addTimeSlot = () => {
  const { currentStartTime, currentEndTime, timeSlots } = this.state;
  if (currentStartTime && currentEndTime) {
    const newSlot = {
      start_time: currentStartTime,
      end_time: currentEndTime
    };
    this.setState({
      timeSlots: [...timeSlots, newSlot],
      currentStartTime: "",
      currentEndTime: ""
    });
  }
}

removeTimeSlot = (index) => {
  const updatedSlots = this.state.timeSlots.filter((_, i) => i !== index);
  this.setState({ timeSlots: updatedSlots });
}

openModal = (type, title, message) => {
  // Add your modal logic here
  console.log(type, title, message);
}
  // Handler methods
  handlePriceTypeChange = (index, type) => {
    const updatedSpaceData = [...this.state.spaceData];
    updatedSpaceData[index].area_price_type = type;

    // Recalculate final price when type changes
    const basePrice = this.state.menu_item?.price;
    const numericValue = updatedSpaceData[index].area_type_wise_value || 0;

    if (type === "fix") {
      updatedSpaceData[index].area_final_price = numericValue === 0 ? basePrice : basePrice + numericValue;
    } else {
      updatedSpaceData[index].area_final_price =
        numericValue === 0 ? basePrice : basePrice + (basePrice * numericValue) / 100;
    }

    this.setState({
      spaceData: updatedSpaceData
    });
  }
  handlePriceValueChange = (index, value) => {
    const updatedSpaceData = [...this.state.spaceData];
    const numericValue = parseFloat(value) || 0;
    updatedSpaceData[index].area_type_wise_value = numericValue;

    // Get the base price (assuming it's stored in state)
    const basePrice = this.state.basePrice || 200; // Default to 200 if not set

    // Calculate final price based on type
    if (updatedSpaceData[index].area_price_type === 'fix') {
      // For fixed amount: base price + the fixed amount
      updatedSpaceData[index].area_final_price = basePrice + numericValue;
    } else {
      // For percentage: base price + (base price * percentage / 100)
      updatedSpaceData[index].area_final_price = basePrice + (basePrice * numericValue / 100);
    }

    this.setState({ spaceData: updatedSpaceData });
  };
  calculateFinalPrice = (spaceData, index) => {
    const space = spaceData[index]
    // Get the base price from state or from the menu_price field
    const basePrice = this.state.basePrice || Number.parseFloat(document.getElementById("menu_price")?.value) || 200

    if (space.area_price_type === "fix") {
      const additionalAmount = Number.parseFloat(space.area_type_wise_value) || 0
      space.area_final_price = additionalAmount === 0 ? basePrice : basePrice + additionalAmount
    } else {
      // Calculate percentage of basePrice
      const percentageValue = Number.parseFloat(space.area_type_wise_value) || 0
      space.area_final_price = percentageValue === 0 ? basePrice : basePrice + (basePrice * percentageValue) / 100
    }
  }

  handleStatusChange = (index, checked) => {
    const updatedSpaceData = [...this.state.spaceData]
    updatedSpaceData[index].area_status = checked
    this.setState({ spaceData: updatedSpaceData })
  }

  handleSaveSpaces = async () => {
    try {
      // Format the data according to the required structure
      const formattedData = {
        hotel_id: this.props.selectedHotelId.id,
        hotel_menu_id: this.state.menuId,
        area_prices: this.state.spaceData.map((space) => ({
          area_name: space.area_name,
          area_price_type: space.area_price_type,
          area_type_wise_value: space.area_type_wise_value,
          area_status: space.area_status,
        })),
      }

      console.log("Saving space data:", formattedData)

      // Send the data to the backend
      const { status, message } = await API(
        this,
        "post",
        URL_PATH.saveSpacesWisePrice, // Assuming this is the endpoint for saving
        formattedData,
      )

      if (status) {
        this.showToast("Space data saved successfully", "success")
      } else {
        this.showToast(message || "Failed to save space data", "error")
      }
    } catch (error) {
      console.error("Save API Error:", error)
      this.showToast("Failed to save space data", "error")
    }
  }

  getCategory = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.listCategory(this.props.selectedHotelId.id))
    if (status == "success") {
      this.setState({
        category: data.data.map((item) => ({
          value: item.id,
          label: item.category_name,
        })),
      })
    } else this.showToast(message, "error")
  }

 create = async () => {
  const formdata = new FormData(document.getElementById("hotelForm"))
  
  formdata.append("hotel_id", this.props.selectedHotelId.id)
  
  if (this.state.category_ids.length == 0) {
    this.showToast("Please select category", "error");
    return;
  }
  
  formdata.append("category_id", `[${this.state.category_ids.map((item) => '"' + item.value + '"')}]`)
  formdata.append("status", this.state.active ? 1 : 0)
  formdata.append("menu_type", this.state.menu_type)
  formdata.append("food_availabel", this.state.menu_available_time_slot)
  
  // Add time slots data when "multiple" is selected
  if (this.state.menu_available_time_slot === "multiple") {
    if (this.state.timeSlots.length === 0) {
      this.showToast("Please add at least one time slot", "error");
      return;
    }
  this.state.timeSlots.forEach((slot, index) => {
        formdata.append(`available_data[${index}][start_time]`, slot.start_time);
        formdata.append(`available_data[${index}][end_time]`, slot.end_time);
      });  } else {
    // For "allday", send empty array or null
    formdata.append("available_data", JSON.stringify([]))
  }
  
  console.log(formdata)
  const { status, message, data } = await API(this, "post", URL_PATH.createMenu, formdata)
  
  if (status == "success") {
    this.showToast(message, "success")
    this.setState({
      menuCreated: true,
      menuId: data.id,
    })
    this.getSpaces()
    this.setState({ mainTabIndex: 1 })
  } else {
    this.showToast(message, "error")
  }
}

createSave = async () => {
  const formdata = new FormData(document.getElementById("hotelForm"))
  
  formdata.append("hotel_id", this.props.selectedHotelId.id)
  
  if (this.state.category_ids.length == 0) {
    this.showToast("Please select category", "error");
    return;
  }
  
  formdata.append("category_id", `[${this.state.category_ids.map((item) => '"' + item.value + '"')}]`)
  formdata.append("status", this.state.active ? 1 : 0)
  formdata.append("menu_type", this.state.menu_type)
  formdata.append("food_availabel", this.state.menu_available_time_slot)
  
  // Add time slots data when "multiple" is selected
  if (this.state.menu_available_time_slot === "multiple") {
    if (this.state.timeSlots.length === 0) {
      this.showToast("Please add at least one time slot", "error");
      return;
    }
  this.state.timeSlots.forEach((slot, index) => {
        formdata.append(`available_data[${index}][start_time]`, slot.start_time);
        formdata.append(`available_data[${index}][end_time]`, slot.end_time);
      });  } else {
    // For "allday", send empty array or null
    formdata.append("available_data", JSON.stringify([]))
  }
  
  console.log(formdata)
  const { status, message, data } = await API(this, "post", URL_PATH.createMenu, formdata)
  
  if (status == "success") {
    this.showToast(message, "success")
    this.setState({
      menuCreated: true,
      menuId: data.id,
    })
     setTimeout(() => {
        this.props.history.push(routes.admin.menu.root(this.props.hotels[0]?.hotel_slug))
      }, 1000)
    // this.getSpaces()
    // this.setState({ mainTabIndex: 1 })
  } else {
    this.showToast(message, "error")
  }
}

  getSlots = (current_start_time = null) => {
    if (current_start_time) {
      current_start_time = moment(current_start_time, ["h:mm A"]).format("HH:mm:ss")
    }

    const start_time = current_start_time ?? "00:00:00"
    const end_time = "23:59:59"

    const slots = []

    const selectedDate = moment().format("YYYY-MM-DD")

    const start = moment(`${selectedDate} ${start_time}`)

    if (start_time) start.add(30, "minutes")

    const end = moment(`${selectedDate} ${end_time}`)

    while (start.isBefore(end)) {
      slots.push({
        label: start.format("hh:mm A"),
        value: start.format("hh:mm A"),
      })
      start.add(30, "minutes")
    }

    return slots
  }
  handleNutritionSuccess = () => {
    this.setState({ mainTabIndex: 0 })
  }

handleAddonsSuccess = () => {
  this.setState({ mainTabIndex: 5 }) // 👈 Set this to the *next* tab index
}

  handleFoodAvailableChange = (event) => {
    this.setState({ menu_available_time_slot: event.target.value })
  }

  handleMenuTypeChange = (event) => {
    this.setState({ menu_type: event.target.value })
  }

  handleStartTimeChange = (event) => {
    this.setState({ start_time: event.target.value })
  }

  handleEndTimeChange = (event) => {
    this.setState({ end_time: event.target.value })
  }

  handleActiveChange = (event) => {
    this.setState({ active: event.target.checked })
  }

  handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      this.setState({ menu_image: file })
    }
  }

  handleImageDelete = () => {
    this.setState({ menu_image: null })
  }

  handleAttributeTabChange = (event, newValue) => {
    this.setState({ attributeTabIndex: newValue })
  }

  handleMainTabChange = (event, newValue) => {
    this.setState({ mainTabIndex: newValue })
  }

  toggleAttributeVariation = () => {
    this.setState((prevState) => ({
      showAttributeVariation: !prevState.showAttributeVariation,
    }))
  }

  handleAddAttributeValue = () => {
    const { newAttributeValue, attributeValues } = this.state

    if (newAttributeValue.trim() === "") {
      return
    }

    this.setState({
      attributeValues: [...attributeValues, newAttributeValue.trim()],
      newAttributeValue: "",
    })
  }

  handleRemoveAttributeValue = (valueToRemove) => {
    const { attributeValues } = this.state
    this.setState({
      attributeValues: attributeValues.filter((value) => value !== valueToRemove),
    })
  }

  handleAttributeValueKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      this.handleAddAttributeValue()
    }
  }

  handleAddAttribute = () => {
    const { newAttributeName, attributeValues, attributes } = this.state

    if (newAttributeName.trim() === "" || attributeValues.length === 0) {
      this.openModal("error", "Error", "Attribute name and at least one value are required")
      return
    }

    const newAttribute = {
      id: Date.now(),
      name: newAttributeName,
      values: attributeValues,
      visible: true,
      used_for_variations: true,
    }

    this.setState({
      attributes: [...attributes, newAttribute],
      newAttributeName: "",
      attributeValues: [],
    })
  }

  handleRemoveAttribute = (id) => {
    const updatedAttributes = this.state.attributes.filter((attr) => attr.id !== id)
    this.setState({ attributes: updatedAttributes })
  }

  formatAttributesForAPI = () => {
    const { attributes } = this.state

    // Format the attributes as expected by the API
    return attributes.map((attr, index) => ({
      attribute_id: (index + 1).toString(),
      attribute_name: attr.name,
      attribute_value: Array.isArray(attr.values) ? attr.values : [attr.values],
    }))
  }

  saveAttributes = async () => {
    const { attributes, menuId } = this.state
    const your_token = localStorage.getItem("token")

    if (attributes.length === 0) {
      this.openModal("error", "Error", "No attributes to save")
      return
    }

    this.setState({ loadingAttributes: true })

    try {
      const formattedAttributes = this.formatAttributesForAPI()
      console.log("formattedAttributes", formattedAttributes)

      const payload = {
        hotel_menu_id: menuId,
        hotel_id: this.props.selectedHotelId.id,
        menu_attributes: formattedAttributes,
      }

      console.log("Saving attributes with payload:", payload)

      const response = await axios.post(`${root_url}/api/hotelowner/hotel-menu/attribute/store`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${your_token}`,
        },
      })

      console.log("Save attributes response:", response)

      if (response.data.status === "success") {
        if (response.data.attributes && Array.isArray(response.data.attributes)) {
          this.setState({
            attributes: response.data.attributes.map((attr) => ({
              id: attr.attribute_id,
              name: attr.attribute_name,
              values: attr.attribute_value,
              visible: true,
              used_for_variations: true,
            })),
          })
        }

        this.showToast("Attributes saved successfully", "success")
      } else {
        this.openModal("error", "Error", response.data.message || "Failed to save attributes")
      }
    } catch (error) {
      console.error("Error saving attributes:", error)

      let errorMessage = "An error occurred while saving attributes"

      if (error.response) {
        if (typeof error.response.data === "string" && error.response.data.startsWith("<!DOCTYPE")) {
          errorMessage = "Server returned an HTML error page. This might be due to an invalid request."
        } else if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        }
      } else if (error.request) {
        errorMessage = "No response from server"
      } else {
        errorMessage = error.message
      }

      this.showToast(errorMessage, "error")
    } finally {
      this.setState({ loadingAttributes: false })
    }
  }

  handleGenerateVariations = async () => {
    const { attributes, menuId } = this.state
    const usableAttributes = attributes.filter((attr) => attr.used_for_variations)
    const your_token = localStorage.getItem("token")

    if (usableAttributes.length === 0) {
      this.openModal("error", "Error", "No attributes selected for variations")
      return
    }

    this.setState({ loadingVariations: true })

    try {
      const formattedAttributes = this.formatAttributesForAPI()

      const payload = {
        hotel_menu_id: menuId,
        hotel_id: this.props.selectedHotelId.id,
        menu_attributes: formattedAttributes,
      }

      console.log("Generating variations with payload:", payload)

      const response = await axios.post(`${root_url}/api/hotelowner/hotel-menu/variation/get`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${your_token}`,
        },
      })

      console.log("Generate variations response:", response)

      if (response.data.status === "success" && response.data.data && Array.isArray(response.data.data)) {
        const variations = response.data.data.map((item) => ({
          id: item.variations_id,
          price: item.variations_regular_price || "0.0",
          salePrice: item.variations_sale_price || "0.0",
          variationData: item.variations_data || [],
        }))

        this.setState({ variations })
        this.showToast("Variations generated successfully", "success")
      } else {
        this.showToast(response.data.message || "Failed to generate variations", "error")
      }
    } catch (error) {
      console.error("Error generating variations:", error)
      this.showToast("An error occurred while generating variations", "error")
    } finally {
      this.setState({ loadingVariations: false })
    }
  }

  handleRemoveVariation = async (id) => {
    const { menuId } = this.state
    console.log("HotelId", this.props.selectedHotelId.id, "hotel_menu_id", menuId, "variations_id", id)

    const { status, message, data } = await API(this, "post", URL_PATH.removeVariation, {
      hotel_id: this.props.selectedHotelId.id,
      hotel_menu_id: menuId,
      variations_id: id,
    })

    console.log("responce dataaaaaaa", data)
    if (status == "success") {
      this.showToast(message, "success")
      const updatedVariations = this.state.variations.filter((v) => v.id !== id)
      this.setState({ variations: updatedVariations })
    } else {
      this.showToast(message, "error")
    }
  }

  handleUpdateVariationPrice = async (variationId) => {
    const { menuId } = this.state
    const variation = this.state.variations.find((v) => v.id === variationId)
    console.log("Arjun", variationId, menuId, variation, variation.price, variation.salePrice)
    if (!variation) return

    const response = await API(this, "post", URL_PATH.updateVariationPrice, {
      variations_id: variationId,
      hotel_id: this.props.selectedHotelId.id,
      hotel_menu_id: menuId,
      variations_regular_price: variation.price || "0.0",
      variations_sale_price: variation.salePrice || "0.0",
    })
    const { status, message, errors } = response

    if (status !== "success") {
      // Default message fallback
      console.log("", status)
      let errorMessage = message || "Sale price should be smaller than regular price"

      // If there are validation errors, get the first one
      if (errors && typeof errors === "object") {
        const firstErrorKey = Object.keys(errors)[0]
        if (errors[firstErrorKey] && errors[firstErrorKey].length > 0) {
          errorMessage = errors[firstErrorKey][0]
        }
      }

      this.showToast(errorMessage, "error")
    }
    if (status === "success") {
      console.log("Price updated successfully")
    } else {
      this.openModal("error", "Error", message)
    }
  }

  handleVariationChange = (id, field, value) => {
    const updatedVariations = this.state.variations.map((v) => {
      if (v.id === id) {
        return { ...v, [field]: value }
      }
      return v
    })

    this.setState({ variations: updatedVariations })
  }

  handleBulkActionClick = (event) => {
    this.setState({ bulkActionAnchorEl: event.currentTarget })
  }

  handleBulkActionClose = () => {
    this.setState({ bulkActionAnchorEl: null })
  }

  componentDidUpdate(prevProps, prevState) {
    // If spaceData was just loaded and basePrice isn't set yet
    if (this.state.spaceData.length > 0 && (prevState.spaceData.length === 0 || !this.state.basePrice)) {
      // Get the base price from the menu_price field
      const basePrice = Number.parseFloat(document.getElementById("menu_price")?.value) || 200

      // Update the state with the base price
      this.setState({ basePrice })

      // Initialize all final prices with the base price if they're not set
      const updatedSpaceData = this.state.spaceData.map((space) => {
        if (!space.area_final_price) {
          return {
            ...space,
            area_final_price: basePrice,
          }
        }
        return space
      })

      if (JSON.stringify(updatedSpaceData) !== JSON.stringify(this.state.spaceData)) {
        this.setState({ spaceData: updatedSpaceData })
      }
    }
  }

  render() {
    const {
      isModalOpen,
      modalType,
      modalTitle,
      modalMessage,
      modalButtonText,
      menuCreated,
      showAttributeVariation,
      attributeTabIndex,
      attributes,
      variations,
      newAttributeName,
      newAttributeValue,
      bulkActionAnchorEl,
      attributeValues,
      loadingAttributes,
      loadingVariations,
      menuId,
      mainTabIndex,
    } = this.state

    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            p: 3,
          }}
        >
          {/* <CardHeader
            title={
              <Typography variant="h5" component="h1" fontWeight="500" color="text.primary">
                Create Menu Item
              </Typography>
            }
            sx={{ pb: 2 }}
          /> */}
          <CardHeader
            title={
              <Header title="Create Menu Item" />

            }

          />
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  bgcolor: "#02111B",
                  backgroundImage: "none",
                  overflow: "hidden",
                  mb: 4,
                }}
              >
                <Box sx={{ p: 3 }}>
                  {/* Main Tabs */}
                  <Box sx={{ mb: 2 }}>
                    <Tabs
                      value={mainTabIndex}
                      onChange={this.handleMainTabChange}
                      sx={{
                        "& .MuiTabs-indicator": {
                          backgroundColor: "#FFC857",
                        },
                        "& .MuiTab-root": {
                          color: "rgba(255, 255, 255, 0.7)",
                          "&.Mui-selected": {
                            color: "#FFC857",
                          },
                        },
                      }}
                    >
                      <Tab label="Item Description" />

                      <Tab label="Space Wise Menu" />
                      <Tab label="Attributes" />
                      <Tab label="Variations" />
                      <Tab label="Add-ons" />
                      <Tab label="Nutrition" />
                      {/* <Tab label="AR Model" /> */}
                    </Tabs>
                  </Box>

                  {/* Item Description Tab */}
                  <Box sx={{ display: mainTabIndex === 0 ? "block" : "none" }}>
                    <form
                      id="hotelForm"
                      name="hotelForm"
                      onSubmit={(e) => {
                        e.preventDefault()
                        return this.create()
                      }}
                    >
                      <Box mb={3}>
                        <TextField
                          fullWidth
                          id="menu_name"
                          name="menu_name"
                          label="Menu Name"
                          placeholder="Enter Menu Name"
                          variant="outlined"
                          required
                        />
                      </Box>

                      <Box mb={3}>
                        <FormControl component="fieldset" fullWidth>
                          <FormLabel component="legend" focused={false}>
                            Menu Type
                          </FormLabel>
                          <RadioGroup
                            aria-label="menu-type"
                            name="menu_type"
                            value={this.state.menu_type}
                            onChange={this.handleMenuTypeChange}
                            row
                          >
                            <FormControlLabel
                              value="veg"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <img src={Veg} alt="Veg icon" width="20" height="20" />
                                  Veg
                                </span>
                              }
                            />

                            <FormControlLabel
                              value="nonveg"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <img src={NonVeg} alt="Non-Veg icon" width="20" height="20" />
                                  Non-Veg
                                </span>
                              }
                            />
                            <FormControlLabel
                              value="jain"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <img src={Jain} alt="Jain icon" width="20" height="20" />
                                  Jain
                                </span>
                              }
                            />

                            <FormControlLabel
                              value="egg"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <img src={EggFood} alt="Egg icon" width="20" height="20" />
                                  Egg Food
                                </span>
                              }
                            />
                            <FormControlLabel
                              value="drinks"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label={
                                <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <img src={Drinks} alt="Egg icon" width="20" height="20" />
                                  Drinks
                                </span>
                              }
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>

                      <Box mb={3}>
                        <TextField
                          fullWidth
                          id="brand_name"
                          name="brand_name"
                          label="Brand Name"
                          placeholder="Enter Brand Name"
                          variant="outlined"
                        />
                      </Box>

                      <Box mb={3}>
                        <TextField
                          fullWidth
                          id="menu_description"
                          name="menu_description"
                          label="Menu Description"
                          placeholder="Enter Menu Description"
                          variant="outlined"
                        />
                      </Box>

                      <Box mb={3}>
                        <FormLabel>Category</FormLabel>

                        <Box display="flex" alignItems="center" gap={2} mt={1}>
                          <Box flex={1}>
                            <Select
                              closeMenuOnSelect={false}
                              components={animatedComponents}
                              isMulti
                              value={this.state.category_ids}
                              onChange={(e) => {
                                this.setState({
                                  category_ids: e,
                                });
                              }}
                              options={this.state.category}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 4,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#041A29",
                                  neutral0: "#02111B",
                                },
                              })}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  padding: "4px",
                                  backgroundColor: "#02111B",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  backgroundColor: "#02111B",
                                  zIndex: 9999,
                                }),
                                menuList: (base) => ({
                                  ...base,
                                  backgroundColor: "#02111B",
                                  ...scrollbarHide,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: "rgba(7, 7, 7, 0.23)",
                                  "&:hover": {
                                    backgroundColor: "#041A29",
                                  },
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "rgba(61, 55, 55, 0.2)",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#FFC857",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#FFC857",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 200, 87, 0.4)",
                                    color: "#FFC857",
                                  },
                                }),
                              }}
                            />
                          </Box>

                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              bgcolor: "#FFC857",
                              "&:hover": { bgcolor: "#E6B54E" },
                            }}
                            onClick={() => {
                              this.props.history.push(routes.admin.category.create);
                            }}
                          >
                            Add New Category
                          </Button>
                        </Box>
                      </Box>


                      <Box mb={3} sx={{ zIndex: 1 }}>
                        <TextField
                          fullWidth
                          id="menu_price"
                          name="menu_price"
                          type="number"
                          label={`Price (${getCurrency(this.props.selectedHotelId.currency)})`}
                          placeholder="Enter Price"
                          variant="outlined"
                          required
                        />
                      </Box>

                      <Box mb={3} sx={{ zIndex: 1 }}>
                        <FormLabel>Menu Image</FormLabel>
                        <Box
                          sx={{
                            mt: 1,
                            border: "1px dashed rgba(255, 255, 255, 0.23)",
                            borderRadius: "8px",
                            p: 3,
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="file"
                            id="menu_image"
                            name="menu_image"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={this.handleImageUpload}
                          />
                          {this.state.menu_image ? (
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                              <Typography>{this.state.menu_image.name}</Typography>
                              <IconButton onClick={this.handleImageDelete} size="small">
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          ) : (
                            <label htmlFor="menu_image" style={{ cursor: "pointer" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px dashed rgba(255, 255, 255, 0.23)",
                                    borderRadius: "4px",
                                    mb: 1,
                                  }}
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7" />
                                    <polyline points="17 8 12 3 7 8" />
                                    <line x1="12" y1="3" x2="12" y2="15" />
                                  </svg>
                                </Box>
                                <Typography>Upload a file or drag and drop</Typography>
                                <Typography variant="caption" color="text.secondary">
                                  PNG, JPG, GIF up to 1.0MB
                                </Typography>
                              </Box>
                            </label>
                          )}
                        </Box>
                      </Box>

                      <Box mb={3}>
                        <FormControl component="fieldset" fullWidth>
                          <FormLabel component="legend" focused={false}>
                            Food Available
                          </FormLabel>
                          <RadioGroup
                            aria-label="food-available"
                            name="menu_available_time_slot"
                            value={this.state.menu_available_time_slot}
                            onChange={this.handleFoodAvailableChange}
                            row
                          >
                            <FormControlLabel
                              value="allday"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label="All Day"
                            />
                            <FormControlLabel
                              value="multiple"
                              control={
                                <Radio
                                  sx={{
                                    color: "#FFC857",
                                    "&.Mui-checked": {
                                      color: "#FFC857",
                                    },
                                  }}
                                />
                              }
                              label="Slot Wise"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>

                      {this.state.menu_available_time_slot === "multiple" && (
                        <Box mb={3}>
                          {/* Time slot inputs */}
                          <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="start-time-label">Start Time</InputLabel>
                            <MuiSelect
                              labelId="start-time-label"
                              id="start_time"
                              name="start_time"
                              value={this.state.currentStartTime}
                              label="Start Time"
                              onChange={(e) => this.setState({ currentStartTime: e.target.value })}
                              sx={{ backgroundColor: "#02111B", color: "#fff" }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    ...scrollbarHide,
                                    backgroundColor: "#02111B",
                                    color: "#fff",
                                    "& .MuiMenuItem-root": {
                                      color: "#fff",
                                      "&:hover": {
                                        backgroundColor: "#041A29",
                                      },
                                    },
                                  },
                                },
                              }}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {this.getSlots().map((slot) => (
                                <MenuItem key={slot.value} value={slot.value}>
                                  {slot.label}
                                </MenuItem>
                              ))}
                            </MuiSelect>
                          </FormControl>

                          {this.state.currentStartTime && (
                            <FormControl fullWidth sx={{ mb: 2 }}>
                              <InputLabel id="end-time-label">End Time</InputLabel>
                              <MuiSelect
                                labelId="end-time-label"
                                id="end_time"
                                name="end_time"
                                value={this.state.currentEndTime}
                                label="End Time"
                                onChange={(e) => this.setState({ currentEndTime: e.target.value })}
                                sx={{ backgroundColor: "#02111B", color: "#fff" }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      ...scrollbarHide,
                                      backgroundColor: "#02111B",
                                      color: "#fff",
                                      "& .MuiMenuItem-root": {
                                        color: "#fff",
                                        "&:hover": {
                                          backgroundColor: "#041A29",
                                        },
                                      },
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="">Select</MenuItem>
                                {this.getSlots(this.state.currentStartTime).map((slot) => (
                                  <MenuItem key={slot.value} value={slot.value}>
                                    {slot.label}
                                  </MenuItem>
                                ))}
                              </MuiSelect>
                            </FormControl>
                          )}

                          {/* Add Slot button */}
                          <Button
                            variant="contained"
                            color="primary"
                           
                           
                            disabled={!this.state.currentStartTime || !this.state.currentEndTime}
                            onClick={this.addTimeSlot}
                            sx={{ mt: 2, borderWidth: 1, borderColor: "#FFC857", color: "#fff", bgcolor: "#041A29", "&:hover": { bgcolor: "#041A29" } }}
                          >
                            Add Time Slot
                          </Button>

                          {/* Display added slots */}
                          {this.state.timeSlots.length > 0 && (
                            <Box mt={2}>
                              <Typography variant="subtitle1">Added Time Slots:</Typography>
                              <List>
                                {this.state.timeSlots.map((slot, index) => (
                                  <ListItem key={index}>
                                    <ListItemText
                                      primary={`${slot.start_time} to ${slot.end_time}`}
                                    />
                                    <IconButton
                                      edge="end"
                                      onClick={() => this.removeTimeSlot(index)}
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                        </Box>
                      )}
                      <Box mb={3}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.active}
                              onChange={this.handleActiveChange}
                              sx={{
                                "& .MuiSwitch-switchBase.Mui-checked": {
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 200, 87, 0.08)",
                                  },
                                },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {},
                              }}
                            />
                          }
                          label="Active"
                        />
                      </Box>

                      <Box mt={4} display="flex" justifyContent="flex-start" gap={2}>
                        {/* SAVE & NEXT Button */}
                        {/* SAVE & NEXT Button */}
                        <Button
                          variant="contained"
                          type="submit"
                          size="large"
                          sx={{
                            px: 4,
                            py: 1,
                            borderRadius: 1,
                            textTransform: "none",
                            fontWeight: 700,
                            bgcolor: "#FFC857",
                            "&:hover": { bgcolor: "#E6B54E" },
                            marginRight: 2 // Add some spacing between buttons
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.create(true); // Pass true to indicate "SAVE & NEXT"
                          }}
                        >
                          SAVE & NEXT
                        </Button>

                        {/* SAVE Button */}
                        <Button
                          variant="contained"
                          type="submit"
                          size="large"
                          sx={{
                            px: 4,
                            py: 1,
                            borderRadius: 1,
                            textTransform: "none",
                            fontWeight: 700,
                            bgcolor: "#FFC857",
                            "&:hover": { bgcolor: "#E6B54E" },
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.createSave(false); // Pass false for regular "SAVE"
                          }}
                        >
                          SAVE
                        </Button>
                        {/* SAVE & ADD CATEGORY Button */}

                      </Box>

                    </form>
                  </Box>
                  {/* spacewise menu tab */}
                  <div style={{ display: mainTabIndex === 1 ? "block" : "none", padding: '16px' }}>
                    {this.state.spaceData?.length > 0 ? (
                      <div>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                          gap: '24px',
                          marginBottom: '32px'
                        }}>
                          {this.state.spaceData.map((space, index) => (
                            <div key={index} style={{
                              background: '#041A29',
                              borderRadius: '8px',
                              padding: '24px',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            }}>
                              {/* Header Row */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '20px'
                              }}>
                                <h3 style={{
                                  margin: 0,
                                  fontSize: '18px',
                                  fontWeight: '500',
                                  color: 'white'
                                }}>
                                  {space.area_name}
                                </h3>

                                <label style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  cursor: 'pointer'
                                }}>
                                  <div style={{
                                    width: '40px',
                                    height: '20px',
                                    borderRadius: '10px',
                                    background: space.area_status ? '#4CAF50' : '#5D6D7E',
                                    position: 'relative',
                                    transition: 'background 0.2s'
                                  }}>
                                    <div style={{
                                      position: 'absolute',
                                      top: '2px',
                                      left: space.area_status ? '22px' : '2px',
                                      width: '16px',
                                      height: '16px',
                                      borderRadius: '50%',
                                      background: '#fff',
                                      transition: 'left 0.2s',
                                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                    }} />
                                  </div>
                                  <span style={{
                                    fontSize: '14px',
                                    color: space.area_status ? '#4CAF50' : '#AEB6BF'
                                  }}>
                                    {space.area_status ? 'Active' : 'Inactive'}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={space.area_status}
                                    onChange={(e) => this.handleStatusChange(index, e.target.checked)}
                                    style={{ display: 'none' }}
                                  />
                                </label>
                              </div>

                              {/* Price Controls */}
                              <div style={{ display: 'grid', gap: '16px' }}>
                                {/* Price Type */}
                                <select
                                  value={space.area_price_type || "fix"}
                                  onChange={(e) => this.handlePriceTypeChange(index, e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    border: '1px solid #02111B',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    backgroundColor: '#02111B',
                                    color: '#EAEDED',
                                    appearance: 'none',
                                    backgroundImage: 'url("data:image/svg+xml;charset=US-ASCII,<svg width=\'12\' height=\'8\' viewBox=\'0 0 12 8\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M1 1L6 6L11 1\' stroke=\'%23D5D8DC\' stroke-width=\'1.5\' stroke-linecap=\'round\'/></svg>")',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right 12px center',
                                    backgroundSize: '12px 8px'
                                  }}
                                >
                                  <option
                                    value="fix"
                                    style={{
                                      backgroundColor: '#02111B',
                                      color: '#EAEDED',
                                      ':hover': {
                                        backgroundColor: '#041A29'
                                      }
                                    }}
                                  >
                                    Fixed Amount
                                  </option>
                                  <option
                                    value="percentage"
                                    style={{
                                      backgroundColor: '#02111B',
                                      color: '#EAEDED',
                                      ':hover': {
                                        backgroundColor: '#041A29'
                                      }
                                    }}
                                  >
                                    Percentage
                                  </option>
                                </select>

                                {/* Price Value */}
                                <div>
                                  <label style={{
                                    display: 'block',
                                    marginBottom: '6px',
                                    fontSize: '13px',
                                    color: '#D5D8DC',
                                    fontWeight: '500'
                                  }}>
                                    {space.area_price_type === "fix" ? "AMOUNT" : "PERCENTAGE"}
                                  </label>
                                  <div style={{ position: 'relative' }}>
                                    {/* <span style={{
                                      position: 'absolute',
                                      left: '12px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      color: '#D5D8DC',
                                      fontSize: '14px'
                                    }}>
                                      ₹
                                    </span> */}
                                    <input
                                      type="number"
                                      value={space.area_type_wise_value === 0 ? "" : space.area_type_wise_value}
                                      onChange={(e) => this.handlePriceValueChange(index, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        border: '1px solid #1C2833',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        backgroundColor: '#02111B',
                                        color: '#EAEDED'
                                      }}
                                    />
                                    {space.area_price_type === "percentage" && (
                                      <span style={{
                                        position: 'absolute',
                                        right: '12px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#D5D8DC',
                                        fontSize: '14px'
                                      }}>
                                        %
                                      </span>
                                    )}
                                  </div>
                                </div>

                                {/* Final Price */}
                                <div>
                                  <label style={{
                                    display: 'block',
                                    marginBottom: '6px',
                                    fontSize: '13px',
                                    color: '#D5D8DC',
                                    fontWeight: '500'
                                  }}>
                                    FINAL PRICE
                                  </label>
                                  <div style={{ position: 'relative' }}>
                                    <span style={{
                                      position: 'absolute',
                                      left: '12px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      color: '#D5D8DC',
                                      fontSize: '14px'
                                    }}>
                                      ₹
                                    </span>
                                    <input
                                      type="text"
                                      value={

                                        space.area_final_price

                                      }
                                      readOnly
                                      style={{
                                        width: '100%',
                                        padding: '10px 12px 10px 32px',
                                        border: '1px solid #1C2833',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        backgroundColor: '#02111B',
                                        color: '#EAEDED'
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Save Button */}
                        <div style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          padding: '16px 0',
                          // borderTop: '1px solid #1C2833'
                        }}>
                          <button

                            style={{
                              backgroundColor: '#FFC857',
                              color: 'black',
                              border: 'none',
                              borderRadius: '6px',
                              padding: '10px 24px',
                              fontSize: '14px',
                              fontWeight: '700',
                              cursor: 'pointer',
                              transition: 'background-color 0.2s',
                              ':hover': {
                                backgroundColor: '#FFC857'
                              }

                            }}
                            onClick={(e) => {
                              this.handleSaveSpaces().then(() => {
                                this.setState({ mainTabIndex: 2 });
                              })
                            }}
                          >
                            SAVE & NEXT
                          </button>
                        </div>
                      </div>
                    ) : (

                      <p style={{
                        color: '#D5D8DC',
                        fontSize: '16px',
                        marginBottom: '24px',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                      }}>
                        No spaces available
                      </p>


                    )}
                  </div>


                  {/* Attributes Tab */}
                  <Box sx={{ display: mainTabIndex === 2 ? "block" : "none" }}>
                    {menuCreated ? (
                      <Box>
                        {/* Attributes Section */}
                        <Box sx={{ mb: 3 }}>

                          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
                            <Button
                              variant="contained"
                              onClick={this.handleAddAttribute}
                              sx={{
                                px: 3,
                                py: 1,
                                borderRadius: 1,
                                textTransform: "none",
                                fontWeight: 700,
                                bgcolor: "#FFC857",
                                "&:hover": { bgcolor: "#E6B54E" },
                              }}
                            >
                              + Add New Attribute
                            </Button>
                          </Box>

                          {attributes.length > 0 ? (
                            <Box>
                              {attributes.map((attribute) => (
                                <Box
                                  key={attribute.id}
                                  sx={{

                                    p: 1,

                                  }}
                                >

                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <Typography variant="body2" color="text.secondary">
                                        Name:
                                      </Typography>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        value={attribute.name}
                                        disabled
                                        sx={{
                                          backgroundColor: "#02111B",
                                          input: { color: "#fff" },
                                          ".MuiOutlinedInput-notchedOutline": {
                                            borderColor: "rgba(255, 255, 255, 0.23)",
                                          },
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                        <Box sx={{ flexGrow: 1 }}>
                                          <Typography variant="body2" color="text.secondary">
                                            Value(s):
                                          </Typography>
                                          <Box
                                            sx={{
                                              minHeight: "38px",
                                              p: 1,
                                              border: "1px solid rgba(255, 255, 255, 0.23)",
                                              borderRadius: "4px",
                                              backgroundColor: "#02111B",
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: 0.5,
                                            }}
                                          >
                                            {Array.isArray(attribute.values) ? (
                                              attribute.values.map((value, index) => (
                                                <Chip
                                                  key={index}
                                                  label={value}
                                                  sx={{
                                                    borderRadius: "0px",
                                                    height: "24px",
                                                    backgroundColor: "#041A29",
                                                    color: "white",

                                                  }}
                                                />
                                              ))
                                            ) : (
                                              <Typography variant="body2" color="text.secondary">
                                                No values
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>
                                        <Button
                                          variant="text"
                                          size="small"
                                          sx={{
                                            color: "white",
                                            backgroundColor: "#BB0A21",
                                            ml: 2,
                                            mt: 2,
                                            alignSelf: "center" // Centers within flex parent
                                          }}
                                          onClick={() => this.handleRemoveAttribute(attribute.id)}
                                        >
                                          <i className="fa fa-trash me-1" aria-hidden="true"></i> DELETE
                                        </Button>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>
                              ))}
                            </Box>
                          ) : (
                            <Box sx={{ textAlign: "center", py: 2 }}>
                              <Typography variant="body2" color="text.secondary">
                                {/* No attributes added yet */}
                              </Typography>
                            </Box>
                          )}

                          <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Name"
                                value={newAttributeName}
                                onChange={(e) => this.setState({ newAttributeName: e.target.value })}
                                placeholder="Size"
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Value"
                                value={newAttributeValue}
                                onChange={(e) => this.setState({ newAttributeValue: e.target.value })}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    this.handleAddAttributeValue()
                                    e.preventDefault()
                                  }
                                }}
                                placeholder="Enter values (press Enter to add)"
                                variant="outlined"
                                size="small"
                              />
                              {/* Chips container moved below the input field */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                  mt: 1,
                                  alignItems: "center",
                                }}
                              >
                                {attributeValues.map((value, index) => (
                                  <Chip
                                    key={index}
                                    label={value}
                                    size="small"
                                    onDelete={() => this.handleRemoveAttributeValue(value)}
                                    sx={{
                                      bgcolor: "#041A29",
                                      color: "white",
                                      borderRadius: "0px",
                                      "& .MuiChip-deleteIcon": {
                                        color: "#BB0A21",
                                        "&:hover": {
                                          color: "#BB0A21",
                                        },
                                      },
                                    }}
                                  />
                                ))}
                              </Box>
                            </Grid>
                          </Grid>

                          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                            <Button
                              variant="contained"
                              onClick={(e) => {
                                this.saveAttributes().then(() => {
                                  this.setState({ mainTabIndex: 3 })
                                })
                              }}
                              disabled={loadingAttributes}
                              sx={{
                                px: 8,
                                py: 1,
                                borderRadius: 1,
                                textTransform: "none",
                                fontWeight: 700,
                                bgcolor: "#FFC857",
                                color: "#000000", // Black text for better contrast
                                "&:hover": {
                                  bgcolor: "#E6B54E",
                                },
                                "&.Mui-disabled": {
                                  bgcolor: "#FFC857", // Same gold color when disabled/loading
                                  color: "#000000", // Keep black text
                                  opacity: 0.7 // Slightly transparent to indicate loading state
                                }
                              }}

                            >
                              {loadingAttributes ? "Saving..." : "SAVE & NEXT"}
                            </Button>
                          </Box>
                        </Box>


                      </Box>
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          Please create the menu item first to add attributes and variations.
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Variations Tab - Same as the Variations sub-tab under Attributes */}
                  <Box sx={{ display: mainTabIndex === 3 ? "block" : "none" }}>
                    {menuCreated ? (
                      <Box>
                        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mb: 2 }}>
                          <Button
                            variant="outlined"
                            onClick={this.handleGenerateVariations}
                            disabled={loadingVariations || attributes.length === 0}
                            sx={{
                              borderColor: "#FFC857",
                              color: "#FFC857",
                              "&:hover": {
                                borderColor: "#E6B54E",
                                backgroundColor: "rgba(255, 200, 87, 0.08)",
                              },
                            }}
                          >
                            {loadingVariations ? "Generating..." : "Generate variations"}
                          </Button>
                        </Box>

                        {variations.length > 0 ? (
                          <TableContainer component={Paper} sx={{ bgcolor: "#02111B", backgroundImage: "none" }}>
                            <Table
                              sx={{
                                "& .MuiTableRow-root": {
                                  "&:nth-of-type(odd)": {
                                    backgroundColor: "#02111B",
                                  },
                                  "&:nth-of-type(even)": {
                                    backgroundColor: "#02111B",
                                  },
                                },
                                "& .MuiTableCell-root": {
                                  borderBottom: "none",
                                },
                              }}
                            >
                              <TableHead>
                                <TableRow
                                  sx={{
                                    borderBottom: "1px solid #FFC857",
                                  }}
                                >
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sr.No</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Variation Data</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Regular Price</TableCell>
                                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Discounted Price</TableCell>
                                  <TableCell align="left" sx={{ color: "white", fontWeight: "bold" }}>
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {variations.map((variation, index) => (
                                  <TableRow key={variation.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell sx={{ color: "text.primary" }}>
                                      {Array.isArray(variation.variationData) ? (
                                        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                                          {variation.variationData.map((value, idx) => (
                                            <Typography
                                              key={idx}
                                              variant="body2"
                                              sx={{
                                                m: 0.5,
                                                color: "#fff",
                                                display: "inline-block",
                                              }}
                                            >
                                              {value}
                                            </Typography>
                                          ))}
                                        </Box>
                                      ) : (
                                        <Typography variant="body2">No data</Typography>
                                      )}
                                    </TableCell>
                                    <TableCell sx={{ color: "text.primary" }}>
                                      <TextField
                                        value={variation.price}
                                        onChange={(e) =>
                                          this.handleVariationChange(variation.id, "price", e.target.value)
                                        }
                                        onBlur={() => this.handleUpdateVariationPrice(variation.id)}
                                        size="small"
                                        type="number"
                                        InputProps={{
                                          startAdornment: (
                                            <Typography variant="body2" sx={{ mr: 0.5, color: "white" }}>
                                              {getCurrency(this.props.selectedHotelId.currency)}
                                            </Typography>
                                          ),
                                        }}
                                        sx={{
                                          width: 100,
                                          backgroundColor: "#041A29",
                                          input: { color: "#fff" },
                                          ".MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#02111B",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell sx={{ color: "text.primary" }}>
                                      <TextField
                                        value={variation.salePrice}
                                        onChange={(e) =>
                                          this.handleVariationChange(variation.id, "salePrice", e.target.value)
                                        }
                                        onBlur={() => this.handleUpdateVariationPrice(variation.id)}
                                        size="small"
                                        type="number"
                                        InputProps={{
                                          startAdornment: (
                                            <Typography variant="body2" sx={{ mr: 0.5, color: "white" }}>
                                              {getCurrency(this.props.selectedHotelId.currency)}
                                            </Typography>
                                          ),
                                        }}
                                        sx={{
                                          width: 100,
                                          backgroundColor: "#041A29",
                                          input: { color: "#fff" },
                                          ".MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#02111B",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell align="right">
                                      <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
                                        <Button
                                          size="small"
                                          variant="contained"
                                          sx={{ color: "white", bgcolor: "#BB0A21", "&:hover": { bgcolor: "#D32F2F" } }}
                                          onClick={() => this.handleRemoveVariation(variation.id)}
                                        >
                                          <i className="fa fa-trash me-1" aria-hidden="true"></i> DELETE
                                        </Button>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <Box sx={{ textAlign: "center", py: 4 }}>
                            <Typography variant="body1" color="text.secondary">
                              No variations yet. Click "Generate variations" to create them from your attributes.
                            </Typography>
                          </Box>
                        )}

                        {/* Add this SAVE & NEXT button at the bottom of the Variations tab */}
                        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                          <Button
                            variant="contained"
                            onClick={() => this.setState({ mainTabIndex: 4 })}
                            sx={{
                              px: 8,
                              py: 1,
                              borderRadius: 1,
                              textTransform: "none",
                              fontWeight: 700,
                              bgcolor: "#FFC857",
                              color: "#000000",
                              "&:hover": {
                                bgcolor: "#E6B54E",
                              },
                            }}
                          >
                            SAVE & NEXT
                          </Button>
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          Please create the menu item first to add variations.
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* nutriation tab */}
<Box sx={{ display: mainTabIndex === 4 ? "block" : "none" }}>
  {menuCreated ? (
    <AddOnsTab 
      hotelId={this.props.selectedHotelId.id} 
      menuId={menuId} 
      openModal={this.openModal}
      onSuccess={() => this.setState({ mainTabIndex: 5 })}
    />
  ) : (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <Typography variant="body1" color="text.secondary">
        Please create the menu item first to add add-ons.
      </Typography>
    </Box>
  )}
</Box>
                  <Box sx={{ display: mainTabIndex === 5 ? "block" : "none" }}>
                    {menuCreated ? (
                      <NutriationTab
                        hotelId={this.props.selectedHotelId.id}
                        menuId={menuId}
                        openModal={this.showToast}
                        onSuccess={this.handleNutritionSuccess}
                      />
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          Please create the menu item first to add nutrition information.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  {/* Add-ons Tab */}

                  {/* <Box sx={{ display: mainTabIndex === 5 ? "block" : "none" }}>
                    {menuCreated ? (
                      <NutritionTab hotelId={this.props.selectedHotelId.id} menuId={menuId} openModal={this.openModal} />
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <Typography variant="body1" color="text.secondary">
                          Please create the menu item first and then add nutrition information.
                        </Typography>
                      </Box>
                    )}
                  </Box> */}

                </Box>
              </Paper>
            </Box>
          </CardContent>
        </Box>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    )
  }
}

export default redux(CreateMenuScreen)